import styled from 'styled-components/macro';

export const StyledBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 0.8rem;
  border-radius: 3.2rem;
  border: 1px solid ${(props) => props.theme.grey.light};
  text-decoration: none;
  &+ span {
      margin-left: 10px;
  }
  .icon {
    margin-right: 0.5rem;
    width: 1.6rem;
  }
  .txt {
    color: ${(props) => props.theme.fontColor.primary};
    text-decoration: none;
    font-size: 1rem;
    font-weight: 700;
  }
  &.accent {
    border-color: ${(props) => props.theme.purple};
    .txt {
      color: ${(props) => props.theme.accent};
      text-decoration: none;
    }
  }
  &.active {
    background-color: ${(props) => props.theme.purple};
    text-decoration: none;
    .txt {
      color: ${(props) => props.theme.white};
      text-decoration: none;
    }
  }
  &.grey-accent {
    border-color: ${(props) => props.theme.grey.light};
    .txt {
      color: ${(props) => props.theme.purple};
      text-decoration: none;
    }
  }
  &.no-border {
    border: 0px;
  }
  &:hover,
  &:focus {
    text-decoration: none;
  }
`;
